import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "resetAllFilter row" };
const _hoisted_2 = { class: "col-12 pt-4 pb-4 border-top" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.resetAllFilters && _ctx.resetAllFilters(...args))),
                class: "resetFiltersButton font7 p-2 text-center d-flex justify-content-center align-items-center border rounded",
                style: { "cursor": "pointer", "height": "48px" }
            }, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("img", {
                        src: "/images/icons/clear.svg",
                        alt: "x",
                        class: "mr-1",
                        height: "16",
                        width: "16"
                    }, null, -1),
                    _createElementVNode("div", { class: "strong d-inline-block" }, "Alle Filter löschen", -1)
                ]))])
        ])
    ]));
}
